// URLs
export const DELIVERY_INFORMATION_URL = "/delivery-information";
export const CLUB_CATCH_URL = "/club-catch";
export const LOGIN_URL = "/login";
export const SIGN_UP_URL = "/register";

// TODO: (SM-1368)
// Change below value to /checkout once new checkout page is ready.
export const CHECKOUT_URL = "/checkout/payment";
export const LOGIN_FORM_URL = "/static/login-form?referrer=/cart";

// Add to cart
export const UNABLE_TO_ADD_TO_CART = "Unable to add to cart";
export const UNABLE_TO_ADD_TO_WISHLIST = "Unable to add to wishlist";

// Remove from cart
export const UNABLE_TO_REMOVE_ITEM = "Unable to remove item from cart";

// Location
export const LOCATION_PLACEHOLDER = "E.g. Sydney, 2000";

// Gift card & Coupon
export const MAX_GIFT_CARD_AMOUNT = 5;
export const GIFT_CARD_CODE_VALIDATION_MESSAGE =
  "Gift card number has 18 digits.";
export const GIFT_CARD_PIN_VALIDATION_MESSAGE = "PIN has 4 digits.";
export const GIFT_CARD_APPLY_VALIDATION_MESSAGE =
  "Please enter an 18-digit gift card number and 4-digit PIN.";
export const GIFT_CARD_SUCCESS_MESSAGE = "Gift card applied successfully";
export const COUPON_SUCCESS_MESSAGE = "Coupon code applied";

// General
export const GENERIC_ERROR = "Something went wrong. Please try again.";
export const EMPTY_CART_MESSAGE = "You have no items in your cart.";
export const PAGE_HEADING = "Shopping Cart";

// Analytics
export const CART_SOURCE_ID = "Cart";
export const CART_PAGE_TYPE = "cart";
export const CLUB_EVENT_ID = 3;
export const CLUB_CTA_ELEMENT_ID = "shipment-1-5-club-catch";

// Experiments
export const CC_PLAN_SELECTION_MODAL_EXPERIMENT =
  "cc_plan_selection_modal_cart_app_sep21";
